<template>
  <SectionContentRedFlagContent v-bind="props" />
</template>

<script setup>
const props = defineProps({
  badgeNumber: {
    type: String,
    default: '5'
  },
  badgeText: {
    type: String,
    default: 'Red Flag No. 5'
  },
  title: {
    type: String,
    default: `The Real Reason You're Tired All the Time (It's Not Just "Aging")`
  },
  introContent: {
    type: String,
    default: `<p>Low energy is one of the most common complaints among men over 35.</p>
<p>The culprits?</p>
<ul>
  <li>Declining mitochondrial function</li>
  <li>Reduced muscle mass</li>
  <li>Hormonal shifts</li>
  <li>Poor sleep</li>
  <li>Chronic stress</li>
</ul>
<p><a href="https://lifeboostcoffee.com/products/new-mito-creamer" target="_blank" rel="noopener noreferrer"><strong>Lifeboost Mitocreamer</strong></a> was designed specifically to support mitochondrial health, the "powerhouses" of your cells.</p>
<p>With MCTs, antioxidants, electrolytes, and collagen, it helps fuel clean, sustained energy without the crash.</p>`
  },
  stainImageSrc: {
    type: String,
    default: ''
  },
  calloutIcon: {
    type: String,
    default: ''
  },
  calloutTitle: {
    type: String,
    default: ''
  },
  calloutContent: {
    type: String,
    default: ''
  },
  calloutAsideImageSrc: {
    type: String,
    default: ''
  },
  calloutAsideImageAlt: {
    type: String,
    default: ''
  },
  showCalloutAsidePlaceholder: {
    type: Boolean,
    default: false
  },
  outroContent: {
    type: String,
    default: ''
  },
  showDivider: {
    type: Boolean,
    default: true
  },
  paddingBottom: {
    type: String,
    default: 'reduced'
  },
  paddingTop: {
    type: String,
    default: 'reduced'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Red Flag Energy',
  inputs: [
    {
      name: 'badgeNumber',
      type: 'text',
      defaultValue: '5'
    },
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: 'Red Flag No. 5'
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: `The Real Reason You're Tired All the Time (It's Not Just "Aging")`
    },
    {
      name: 'introContent',
      type: 'richText',
      defaultValue: `<p>Low energy is one of the most common complaints among men over 35.</p>
<p>The culprits?</p>
<ul>
  <li>Declining mitochondrial function</li>
  <li>Reduced muscle mass</li>
  <li>Hormonal shifts</li>
  <li>Poor sleep</li>
  <li>Chronic stress</li>
</ul>
<p><a href="https://lifeboostcoffee.com/products/new-mito-creamer" target="_blank" rel="noopener noreferrer"><strong>Lifeboost Mitocreamer</strong></a> was designed specifically to support mitochondrial health, the "powerhouses" of your cells.</p>
<p>With MCTs, antioxidants, electrolytes, and collagen, it helps fuel clean, sustained energy without the crash.</p>`
    },
    {
      name: 'stainImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: ''
    },
    {
      name: 'calloutIcon',
      type: 'text',
      enum: ['', 'coffee', 'alert'],
      defaultValue: ''
    },
    {
      name: 'calloutTitle',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'calloutContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'calloutAsideImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: ''
    },
    {
      name: 'calloutAsideImageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'showCalloutAsidePlaceholder',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'outroContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    }
  ]
})
</script>
